import { connect } from 'react-redux';

import CardPrice from './CardPrice';

const mapStateToProps = (state) => ({
    priceDisplayMode: state.settings.data.priceDisplayMode,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(CardPrice);
